import React from 'react';
import Typography from '@material-ui/core/Typography';
import startCase from 'lodash.startcase';

export default function ApplicationDetails({ business }) {
  return (
    <>
      <Typography align="justify" variant="h6" gutterBottom>
        <b> Business Name : </b> {business.name}
      </Typography>
      <Typography variant="h6" align="justify" gutterBottom>
        <b> Selling model : </b> {business.sellerType}
      </Typography>
      <Typography align="justify" variant="h6">
        <b> Primary platform : </b> {startCase(business.sellerStore)}
      </Typography>
    </>
  );
}
